<template>
  <div class="checkbox" :class="{ 'checkbox--first': isFirst }">
    <label class="checkbox__label" >
      <input
        type="checkbox"
        :required="required"
        @change="$emit('input', !value)"
        class="checkbox__input"
        :checked="value"
        :value="value"
      >
      <span class="checkbox__custom" v-html="content"/>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    },
    isFirst: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox {
  position: relative;
  cursor: pointer;
  text-align: left;
  padding-left: 40px;

  &--first {
    padding-top: 30px;
  }

  &__label {
    position: relative;
  }

  &__custom {
    color: $accent-opposite-color;
    font-size: 14px;
    cursor: pointer;

    &::before,
    &::after {
      content: "";
      position: absolute;
      display: block;
    }

    &::before {
      top: 0;
      left: -40px;
      width: 24px;
      height: 24px;
      border: 3px solid $accent-opposite-color;
    }

    &::after {
      top: 6px;
      left: -34px;
      background-color: $accent-opposite-color;
      width: 12px;
      height: 12px;
      opacity: 0;
      transition: opacity .1s;
    }

    /deep/ a {
      color: inherit;
    }
  }

  &__input {
    @include visually-hidden;
    left: -35px;
    top: 10px;
  }

  &__input:checked + &__custom::after {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Checkbox.vue